import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59bc54ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "services-new" }
const _hoisted_2 = { class: "services-new__drawer-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<section class=\"hero-section\" data-v-59bc54ab><div class=\"hero-content\" data-v-59bc54ab><h1 class=\"hero-title\" data-v-59bc54ab> Shanghai&#39;s most trusted experts in<br data-v-59bc54ab>large scale UI and UX design </h1><div class=\"hero-copy\" data-v-59bc54ab><p class=\"hero-subtitle\" data-v-59bc54ab> Digital Creative Asia is a UI/UX design agency in Shanghai. We craft advanced digital experiences for China,<br data-v-59bc54ab>APAC, and global markets that perform at scale. </p></div></div></section><section class=\"hero-image-section\" data-v-59bc54ab><div class=\"hero-image-container\" data-v-59bc54ab><img src=\"/video-area.png\" alt=\"UI/UX Design Examples\" class=\"hero-image\" data-v-59bc54ab></div></section><section class=\"services-intro-section\" data-v-59bc54ab><div class=\"services-intro-content\" data-v-59bc54ab><p class=\"services-intro-label\" data-v-59bc54ab>SERVICES</p><h2 class=\"services-intro-title\" data-v-59bc54ab> Premium UX and UI design for<br data-v-59bc54ab>mission critical digital systems </h2></div></section>", 3)
const _hoisted_6 = { class: "services-grid-section" }
const _hoisted_7 = { class: "services-grid" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "service-title" }, "User Research", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-description" }, " Gain a clear understanding of your users and their behaviors, revealing the insights needed to shape products that feel intuitive, relevant, and aligned with real world expectations. ", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "service-title" }, "UX Design", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-description" }, " Create seamless product journeys that simplify complexity and deliver clarity, enabling users to move through your digital ecosystem with confidence and complete key tasks effortlessly. ", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "service-title" }, "UI Design", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-description" }, " Elevate your digital products with refined visual design that communicates credibility and quality, strengthening brand perception while improving overall usability and engagement. ", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "service-title" }, "Design Systems", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-description" }, " Establish a unified design foundation that brings consistency, scalability, and efficiency across teams, ensuring every product interaction is coherent and built for long term growth. ", -1))
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "service-title" }, "Design Documentation", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-description" }, " Receive precise, developer ready specifications that remove ambiguity, speed up implementation, and keep multi team collaboration smooth throughout large scale projects. ", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "service-title" }, "Prototyping and Validation", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-description" }, " Validate key ideas early with interactive prototypes that uncover usability issues, reduce risk, and ensure your final product resonates with users before development begins. ", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "work-section" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "work-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "work-label" }, "FEATURED WORK"),
  /*#__PURE__*/_createElementVNode("h2", { class: "work-title" }, [
    /*#__PURE__*/_createTextVNode(" Design excellence for brands that expect"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("their digital products to lead, not follow ")
  ])
], -1))
const _hoisted_28 = { class: "work-grid" }
const _hoisted_29 = { class: "project-card-media" }
const _hoisted_30 = { class: "project-info" }
const _hoisted_31 = { class: "project-title" }
const _hoisted_32 = { class: "project-client" }
const _hoisted_33 = {
  key: 0,
  class: "project-type"
}
const _hoisted_34 = { class: "clients-section" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "clients-label" }, "SELECTED CLIENTS", -1))
const _hoisted_36 = { class: "benefits-section" }
const _hoisted_37 = { class: "benefits-content" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "benefits-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "benefits-label" }, "SERVICES"),
  /*#__PURE__*/_createElementVNode("h2", { class: "benefits-title" }, [
    /*#__PURE__*/_createTextVNode(" Create meaningful user journeys that"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("convert and retain customers ")
  ])
], -1))
const _hoisted_39 = { class: "benefits-grid" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "benefit-title" }, "Clear Navigation", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "benefit-description" }, " Help customers reach their goals quickly through intuitive pathways, streamlined flows, and a navigation structure that removes friction across every touchpoint. ", -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "benefit-title" }, "Unified experience", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "benefit-description" }, " Bring branding, usability, data, accessibility, and functionality together into one cohesive experience that feels consistent, reliable, and intelligent from start to end. ", -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "benefit-title" }, "Heightened Satisfaction", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "benefit-description" }, " Create moments of clarity and delight through thoughtful interaction patterns and information architecture that make exploring your product feel effortless. ", -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "benefit-title" }, "Improved ROI", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "benefit-description" }, " Lower long term development and marketing costs by establishing strong UX foundations early, reducing rework and driving more efficient product decisions. ", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "benefit-title" }, "Increased Loyalty", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "benefit-description" }, " Guide users to the right solutions with clarity and speed, strengthening trust and encouraging repeat engagement with your brand over time. ", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "benefit-title" }, "Solution Focused", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "benefit-description" }, " Win more customers through UX design shaped around real pain points and user needs, addressing challenges proactively rather than reacting later. ", -1))
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = { class: "blog-content" }
const _hoisted_59 = { class: "blog-header" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blog-title-wrapper" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "blog-label" }, "FROM OUR BLOG"),
  /*#__PURE__*/_createElementVNode("h2", { class: "blog-title" }, [
    /*#__PURE__*/_createTextVNode(" Unfiltered UI/UX insights from our"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("expert design team ")
  ])
], -1))
const _hoisted_61 = {
  key: 0,
  class: "blog-nav"
}
const _hoisted_62 = ["disabled"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M19 12H5M5 12L12 19M5 12L12 5",
    stroke: "currentColor",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 12H19M19 12L12 5M19 12L12 19",
    stroke: "currentColor",
    "stroke-width": "1.5"
  })
], -1))
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = ["href"]
const _hoisted_69 = {
  key: 0,
  class: "blog-card-image"
}
const _hoisted_70 = ["src", "alt"]
const _hoisted_71 = { class: "blog-card-meta" }
const _hoisted_72 = { class: "blog-card-date" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "blog-card-dot" }, "•", -1))
const _hoisted_74 = { class: "blog-card-author" }
const _hoisted_75 = ["innerHTML"]
const _hoisted_76 = { class: "faq-section" }
const _hoisted_77 = { class: "faq-content" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { class: "faq-question-left" }
const _hoisted_80 = { class: "faq-number" }
const _hoisted_81 = { class: "faq-title" }
const _hoisted_82 = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 5V19M5 12H19",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M5 12H19",
  stroke: "currentColor",
  "stroke-width": "1.5"
}, null, -1))
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = { class: "faq-answer-content" }
const _hoisted_89 = /*#__PURE__*/_createStaticVNode("<footer class=\"footer-section\" data-v-59bc54ab><div class=\"footer-content\" data-v-59bc54ab><div class=\"footer-column\" data-v-59bc54ab><h4 class=\"footer-heading\" data-v-59bc54ab>COMPANY</h4><ul class=\"footer-links\" data-v-59bc54ab><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Who We Are</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Insights</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Contact</a></li></ul></div><div class=\"footer-column\" data-v-59bc54ab><h4 class=\"footer-heading\" data-v-59bc54ab>SOLUTIONS</h4><ul class=\"footer-links\" data-v-59bc54ab><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Platforms</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Products</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Commerce</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>AI</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Systems</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>China Tech</a></li></ul></div><div class=\"footer-column\" data-v-59bc54ab><h4 class=\"footer-heading\" data-v-59bc54ab>CAPABILITIES</h4><ul class=\"footer-links\" data-v-59bc54ab><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Strategy</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>User Research</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Product Design</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Engineering</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>AI &amp; Data</a></li><li data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Security &amp; Compliance</a></li></ul></div><div class=\"footer-column\" data-v-59bc54ab><h4 class=\"footer-heading\" data-v-59bc54ab>CONTACT</h4><p class=\"footer-address\" data-v-59bc54ab>No. 28 Jiangyao Road, Lab 902,<br data-v-59bc54ab>Building T2, Qiantan, Pudong New<br data-v-59bc54ab>Area, Shanghai, China</p><p class=\"footer-phone\" data-v-59bc54ab>+86 (21) 2027 0599</p><p class=\"footer-email\" data-v-59bc54ab>hello@digitalcreative.asia</p><p class=\"footer-social\" data-v-59bc54ab>LinkedIn</p></div></div><div class=\"footer-bottom\" data-v-59bc54ab><div class=\"footer-logo\" data-v-59bc54ab><img src=\"/assets/icons/dca-logo.svg\" alt=\"DCA Logo\" class=\"logo-icon\" data-v-59bc54ab></div><p class=\"footer-copyright\" data-v-59bc54ab>© 2026 - Digital Creative Asia 星山网络科技（上海）有限公司 / 沪ICP备19005446号-1</p><div class=\"footer-legal\" data-v-59bc54ab><a href=\"#\" data-v-59bc54ab>Privacy Policy</a><a href=\"#\" data-v-59bc54ab>Terms</a><a href=\"#\" data-v-59bc54ab>Trust Center</a></div></div></footer>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomCursor = _resolveComponent("CustomCursor")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_ClippingAnimation = _resolveComponent("ClippingAnimation")!
  const _component_Anchor = _resolveComponent("Anchor")!
  const _component_PartnersNew = _resolveComponent("PartnersNew")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "service-card" }, eventListeners), _hoisted_10, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "service-card" }, eventListeners), _hoisted_13, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "service-card" }, eventListeners), _hoisted_16, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "service-card" }, eventListeners), _hoisted_19, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "service-card" }, eventListeners), _hoisted_22, 16)
            ]),
            _: 1
          }),
          _createVNode(_component_CustomCursor, { text: "View" }, {
            default: _withCtx(({ eventListeners }) => [
              _createElementVNode("div", _mergeProps({ class: "service-card" }, eventListeners), _hoisted_25, 16)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("section", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
            return (_openBlock(), _createElementBlock("div", {
              key: project.id,
              class: "project-item"
            }, [
              _createVNode(_component_Anchor, {
                disabled: project.coming_soon,
                route: {
                        name: _ctx.Route.CaseStudy,
                        meta: { theme: project?.theme?.value === 'dark' ? _ctx.Theme.Dark : _ctx.Theme.Default },
                        params: {
                            slug: project.slug,
                            gradient: project?.list_cover?.gradient_background ?? project?.cover?.gradient_background ?? 'linear-gradient(140deg, #424242, #121212)',
                        },
                    },
                class: "project-card-link"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_CustomCursor, {
                      text: project.coming_soon ? 'Coming Soon' : 'View'
                    }, {
                      default: _withCtx(({ eventListeners }) => [
                        _createVNode(_component_ClippingAnimation, { interactive: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Picture, _mergeProps({
                              image: project?.list_cover,
                              width: "100%",
                              height: "100%",
                              cover: ""
                            }, eventListeners), null, 16, ["image"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ])
                ]),
                _: 2
              }, 1032, ["disabled", "route"]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_Anchor, {
                  disabled: project.coming_soon,
                  route: {
                            name: _ctx.Route.CaseStudy,
                            params: {
                                slug: project.slug,
                                gradient: project?.list_cover?.gradient_background ?? project?.cover?.gradient_background ?? 'linear-gradient(140deg, #424242, #121212)'
                            }
                        }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_31, _toDisplayString(project.title), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "route"]),
                _createElementVNode("p", _hoisted_32, _toDisplayString(project.client_name), 1),
                (project.tags)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(project.tags.join(' / ')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("section", _hoisted_34, [
        _hoisted_35,
        _createVNode(_component_PartnersNew)
      ]),
      _createElementVNode("section", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_CustomCursor, { text: "View" }, {
              default: _withCtx(({ eventListeners }) => [
                _createElementVNode("div", _mergeProps({ class: "benefit-card" }, eventListeners), _hoisted_42, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_CustomCursor, { text: "View" }, {
              default: _withCtx(({ eventListeners }) => [
                _createElementVNode("div", _mergeProps({ class: "benefit-card" }, eventListeners), _hoisted_45, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_CustomCursor, { text: "View" }, {
              default: _withCtx(({ eventListeners }) => [
                _createElementVNode("div", _mergeProps({ class: "benefit-card" }, eventListeners), _hoisted_48, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_CustomCursor, { text: "View" }, {
              default: _withCtx(({ eventListeners }) => [
                _createElementVNode("div", _mergeProps({ class: "benefit-card" }, eventListeners), _hoisted_51, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_CustomCursor, { text: "View" }, {
              default: _withCtx(({ eventListeners }) => [
                _createElementVNode("div", _mergeProps({ class: "benefit-card" }, eventListeners), _hoisted_54, 16)
              ]),
              _: 1
            }),
            _createVNode(_component_CustomCursor, { text: "View" }, {
              default: _withCtx(({ eventListeners }) => [
                _createElementVNode("div", _mergeProps({ class: "benefit-card" }, eventListeners), _hoisted_57, 16)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(["blog-section", { 'blog-section--carousel': _ctx.hasBlogCarousel }])
      }, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            (_ctx.hasBlogCarousel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                  _createElementVNode("button", {
                    class: "blog-nav-btn",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevBlog && _ctx.prevBlog(...args))),
                    disabled: _ctx.currentBlogIndex === 0
                  }, _hoisted_64, 8, _hoisted_62),
                  _createElementVNode("button", {
                    class: "blog-nav-btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextBlog && _ctx.nextBlog(...args))),
                    disabled: _ctx.currentBlogIndex >= _ctx.blogPosts.length - 3
                  }, _hoisted_67, 8, _hoisted_65)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["blog-grid", { 'blog-grid--carousel': _ctx.hasBlogCarousel }]),
            style: _normalizeStyle({ '--blog-index': _ctx.currentBlogIndex })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blogPosts, (post, index) => {
              return (_openBlock(), _createBlock(_component_CustomCursor, {
                text: "View",
                key: post.id || index
              }, {
                default: _withCtx(({ eventListeners }) => [
                  _createElementVNode("div", _mergeProps({ class: "blog-card" }, eventListeners), [
                    _createElementVNode("a", {
                      href: `/blog/${post.slug}`,
                      class: "blog-card-link"
                    }, [
                      (post.cover && post.cover.desktop_asset)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _createElementVNode("img", {
                              src: post.cover.desktop_asset.url,
                              alt: post.title
                            }, null, 8, _hoisted_70)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("span", _hoisted_72, _toDisplayString(post.updated_at), 1),
                        _hoisted_73,
                        _createElementVNode("span", _hoisted_74, "by " + _toDisplayString(post.author?.name || 'Digital Creative'), 1)
                      ]),
                      _createElementVNode("h3", {
                        class: "blog-card-title",
                        innerHTML: post.title
                      }, null, 8, _hoisted_75)
                    ], 8, _hoisted_68)
                  ], 16)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ], 6)
        ])
      ], 2),
      _createElementVNode("section", _hoisted_76, [
        _createElementVNode("div", _hoisted_77, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faqs, (faq, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "faq-item",
              key: index
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["faq-question", { 'faq-question--open': _ctx.openFaq === index }]),
                onClick: ($event: any) => (_ctx.toggleFaq(index))
              }, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("span", _hoisted_80, _toDisplayString(String(index + 1).padStart(2, '0')), 1),
                  _createElementVNode("span", _hoisted_81, _toDisplayString(faq.question), 1)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["faq-icon", { 'faq-icon--open': _ctx.openFaq === index }])
                }, [
                  (_ctx.openFaq !== index)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_82, _hoisted_84))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_85, _hoisted_87))
                ], 2)
              ], 10, _hoisted_78),
              _createElementVNode("div", {
                class: _normalizeClass(["faq-answer", { 'faq-answer--open': _ctx.openFaq === index }])
              }, [
                _createElementVNode("div", _hoisted_88, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(faq.answer, (paragraph, pIndex) => {
                    return (_openBlock(), _createElementBlock("p", { key: pIndex }, _toDisplayString(paragraph), 1))
                  }), 128))
                ])
              ], 2)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_89
  ]))
}